import { render } from "./CreateOrganization.vue?vue&type=template&id=7bf26a4b&scoped=true"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"

import "./CreateOrganization.vue?vue&type=style&index=0&id=7bf26a4b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf26a4b"]])

export default __exports__